import { useState } from "react";
import PortalNav from "../components/PortalNav";
import { useAuth } from "../context/AuthContext";
import { Lock } from "lucide-react";
import { toast, Toaster } from "sonner";

export default function Alumni() {
  const { user } = useAuth();
  const [email, setEmail] = useState("");
  const day = user?.day ?? 7;
  const unlocked = day >= 21;

  const capture = (e) => {
    e.preventDefault();
    if (!email) return;
    toast.success("You're on the list. We'll be in touch.");
    setEmail("");
  };

  return (
    <div className="portal-body" data-testid="alumni-page">
      <Toaster position="top-center" />
      <header style={{ background: "var(--charcoal)", color: "var(--ivory)", padding: "28px 24px 32px" }}>
        <div className="container-x">
          <p className="eyebrow eyebrow-light">Alumni</p>
          <h1 style={{ fontFamily: "var(--serif)", fontWeight: 300, fontSize: "clamp(1.8rem, 4vw, 2.4rem)", margin: "10px 0" }}>Your journey doesn't end here.</h1>
          <p style={{ color: "rgba(250,246,238,.55)", fontSize: ".95rem" }}>{unlocked ? "You've closed the residency. Welcome to the Society." : `Unlocks on Day 21. You're on Day ${day}.`}</p>
        </div>
      </header>

      <main className="container-x" style={{ padding: "32px 24px", display: "grid", gap: 24 }}>
        {!unlocked && (
          <div className="portal-card" style={{ display: "flex", alignItems: "center", gap: 20, padding: 28, background: "rgba(184,150,90,.06)" }} data-testid="alumni-lock">
            <div style={{ width: 48, height: 48, border: "1px solid var(--gold)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--gold)" }}>
              <Lock size={18} />
            </div>
            <div>
              <p className="eyebrow" style={{ marginBottom: 6 }}>Locked until Day 21</p>
              <p className="body-sm" style={{ margin: 0 }}>Complete your residency to unlock lifetime Society access. Everything you're about to see is waiting.</p>
            </div>
          </div>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 12 }} data-testid="alumni-cards">
          {[
            { h: "Saviar Society Membership", p: "Lifetime access to alumni-only events, tastings, and the members' portal." },
            { h: "Soft Life Planner", p: "Your post-residency companion — protocols, rituals, and integration frameworks." },
            { h: "1:1 Coaching Continuation", p: "Ongoing guidance from your Saviar coach. Bi-weekly or monthly cadence." },
          ].map((c) => (
            <div key={c.h} className="portal-card" style={{ position: "relative", opacity: unlocked ? 1 : 0.55 }}>
              <p className="eyebrow" style={{ marginBottom: 12 }}>Next Chapter</p>
              <h3 style={{ margin: "0 0 10px" }}>{c.h}</h3>
              <p className="body-sm" style={{ margin: 0 }}>{c.p}</p>
            </div>
          ))}
        </div>

        <div className="portal-card" data-testid="alumni-newsletter">
          <p className="eyebrow" style={{ marginBottom: 12 }}>Alumni Newsletter</p>
          <h3>Whispered notes from the Society.</h3>
          <p className="body-sm" style={{ marginTop: 8, marginBottom: 20 }}>Rituals, invitations, and softening notes — sent every full moon.</p>
          <form onSubmit={capture} style={{ display: "flex", gap: 12 }}>
            <input type="email" required placeholder="your@email.com" value={email} onChange={(e) => setEmail(e.target.value)} style={{ flex: 1, padding: "12px 0", background: "transparent", border: "none", borderBottom: "1px solid rgba(184,150,90,.3)", color: "var(--charcoal)", outline: "none" }} data-testid="newsletter-email" />
            <button type="submit" className="btn btn-primary" data-testid="newsletter-submit">Join</button>
          </form>
        </div>
      </main>
      <PortalNav />
    </div>
  );
}
